import { Link } from 'react-router-dom';
import { cn } from '../../lib/utils';

interface Props {
  className?: string;
  /** Render as a link to home (default true) */
  linked?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const wordSize = { sm: 'text-xl', md: 'text-[1.7rem]', lg: 'text-4xl' };

export function Logo({ className, linked = true, size = 'md' }: Props) {
  const content = (
    <span
      className={cn(
        'display inline-flex items-center font-bold tracking-tight text-foreground',
        wordSize[size],
        className
      )}
    >
      <span className="text-gradient-dusk">MovieMe</span>
    </span>
  );

  if (!linked) return content;
  return (
    <Link
      to="/"
      className="rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      aria-label="MovieMe home"
    >
      {content}
    </Link>
  );
}
